"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonsCommon = void 0;
exports.buttonsCommon = {
    minWidth: '5rem',
    textTransform: 'none',
    fontFamily: 'Messina Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    letterSpacing: '0',
    borderRadius: '2rem',
};
